import { Building2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { Bank } from "@/apis/gql/types";
import { Checkbox } from "@/components/ui/checkbox";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";

import BankCard from "./bank-card";

type Props = {
  bank: Bank;
  acknowledged: boolean;
  onAcknowledgeChange: (value: boolean) => void;
};

export const ConnectionStepFintsWarning = ({
  bank,
  acknowledged,
  onAcknowledgeChange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Building2 className="h-5 w-5" />
          {t("bank_connections.fints_warning.title")}
        </DialogTitle>
      </DialogHeader>
      <BankCard
        bank={bank}
        onSelect={() => {}}
        disabled={false}
        nonSelectView={true}
      />

      <Separator />

      <div className="space-y-4">
        <p className="text-sm text-muted-foreground leading-relaxed">
          {t("bank_connections.fints_warning.description")}
        </p>
        <div className="flex items-start gap-3">
          <Checkbox
            id="fints-ack"
            checked={acknowledged}
            onCheckedChange={(val) => onAcknowledgeChange(Boolean(val))}
          />
          <Label htmlFor="fints-ack" className="text-sm leading-6">
            {t("bank_connections.fints_warning.acknowledgement_label")}
          </Label>
        </div>
      </div>
    </div>
  );
};
